import { atom } from 'recoil';

export const MobileShowLocationButtonState = atom({
    key: 'MobileShowLocationButtonState', 
    default: false, 
});